var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCartDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.76367,65a3.75,3.75,0,1,0-3.75,3.75A3.75442,3.75442,0,0,0,28.76367,65Zm-6,0a2.25,2.25,0,1,1,2.25,2.25A2.25278,2.25278,0,0,1,22.76367,65Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.76367,65a3.75,3.75,0,1,0-3.75,3.75A3.75442,3.75442,0,0,0,62.76367,65Zm-6,0a2.25,2.25,0,1,1,2.25,2.25A2.25278,2.25278,0,0,1,56.76367,65Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.28418,58.17383a.74912.74912,0,0,0,.72949.57617h40v-1.5H24.60645l-1.106-4.645,38.5874-3.85895a.74928.74928,0,0,0,.64258-.52539l8-26a.74955.74955,0,0,0-.7168-.9707H42a.7502.7502,0,0,0-.75.75V38.18945l-4.71973-4.71972-1.06054,1.06054,6,6a.74971.74971,0,0,0,1.06054,0l6-6-1.06054-1.06054L42.75,38.18945V22.75H68.99805L61.44336,47.30322,23.1499,51.13306,16.39185,22.75H38v-1.5H16.03467l-1.29151-5.42383a.7491.7491,0,0,0-.72949-.57617h-6v1.5H13.4209Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCartDownload);
export default __webpack_public_path__ + "static/media/icon_cart_download.7b13601223f5e9be375f4bd0ca398529.svg";
export { ForwardRef as ReactComponent };